import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import API_BASE_URL from '../api';

const PoliticalInfo = () => {
  const [politicalInfo, setPoliticalInfo] = useState({
    politicalSpectrum: 50, // Default value for the slider, from 0 (liberal) to 100 (conservative)
    flexibleOnViews: '',
  });

  const [message, setMessage] = useState('');
  const [isNewUser, setIsNewUser] = useState(false);

  const getAuthToken = () => localStorage.getItem('stack_access_token');
  const navigate = useNavigate();

  useEffect(() => {
    const token = getAuthToken();
    fetch(`${API_BASE_URL}/api/political-info`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Stack-Access-Token': token,
      },
    })
      .then((response) => {
        if (response.status === 404) {
          setIsNewUser(true);
          setMessage(
            'No political info found. Please set your political info.',
          );
          return;
        }
        if (!response.ok) {
          throw new Error('Failed to fetch political info');
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          const politicalData = data.reduce((acc, item) => {
            if (
              item.question_text ===
              'Where do you fall on the political spectrum?'
            )
              acc.politicalSpectrum = item.answer_int;
            if (item.question_text === 'Are you flexible on this?')
              acc.flexibleOnViews = item.answer_text;
            return acc;
          }, {});
          setPoliticalInfo(politicalData);
        }
      })
      .catch((error) => {
        console.error('Error fetching political info:', error);
        setMessage('Error fetching political info.');
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = getAuthToken();

    const payload = {
      politicalSpectrum: parseInt(politicalInfo.politicalSpectrum, 10),
      flexibleOnViews: politicalInfo.flexibleOnViews,
    };

    const method = isNewUser ? 'POST' : 'PUT';

    try {
      const response = await fetch(`${API_BASE_URL}/api/political-info`, {
        method: method,
        headers: {
          'X-Stack-Access-Token': token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to update political info');
      }

      setPoliticalInfo(payload); // Set state to the values that were just submitted
      setMessage('Political info updated successfully.');

      setTimeout(() => {
        navigate('/kids-info');
      }, 2000);

      setIsNewUser(false);
    } catch (error) {
      console.error('Error setting political info:', error);
      setMessage('Failed to update political info.');
    }
  };

  const handleChange = (e) => {
    setPoliticalInfo({
      ...politicalInfo,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: '#0D2329' }}
    >
      <Navbar />
      <div className="flex-1 flex justify-center items-center">
        <div
          className="w-full max-w-md p-8 rounded-lg shadow-md"
          style={{ backgroundColor: '#05664f' }}
        >
          <h1 className="text-4xl font-bold text-white text-center mb-6">
            Political Info
          </h1>
          {message && (
            <p className="text-sm text-red-200 text-center mb-4">{message}</p>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="text-white">
              <label className="block text-sm font-medium">
                Where do you fall on the political spectrum?
              </label>
              <input
                type="range"
                name="politicalSpectrum"
                min="0"
                max="100"
                value={politicalInfo.politicalSpectrum}
                onChange={handleChange}
                className="w-full"
              />
              <div className="flex justify-between">
                <span>Liberal</span>
                <span>Conservative</span>
              </div>
            </div>

            <div className="text-white">
              <label className="block text-sm font-medium">
                Are you flexible on this?
              </label>
              <div className="flex space-x-4">
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="flexibleOnViews"
                    value="Yes"
                    checked={politicalInfo.flexibleOnViews === 'Yes'}
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">Yes</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="flexibleOnViews"
                    value="Maybe"
                    checked={politicalInfo.flexibleOnViews === 'Maybe'}
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">Maybe</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="flexibleOnViews"
                    value="No"
                    checked={politicalInfo.flexibleOnViews === 'No'}
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">No</span>
                </label>
              </div>
            </div>

            <button
              type="submit"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Next
            </button>

            <button
              type="button"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mt-2"
              onClick={() => navigate('/career-info')} // Navigate back to the previous form
            >
              Previous
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PoliticalInfo;
